import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const voucher = [
    {
        path: baseUrlTenant,
        component: () => import("@/view/layout/Layout"),
        children: [
            // {
            //     path: "confirm",
            //     name: "confirm",
            //     component: () => import("@/view/pages/confirm/List")
            // },
            {
                path: "confirm-submit",
                name: "confirm-submit",
                component: () => import("@/view/pages/confirm/Submit")
            }
        ]
    },
]

export default voucher
